if (!customElements.get('carousel-slider')) {
  customElements.define(
    'carousel-slider',
    class CarouselSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));

        if (this.prevButton) this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get slides() {
        return Array.from(this.track.children);
      }

      get step() {
        const slides = this.slides;
        return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : this.track.clientWidth;
      }

      get maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      // Distinct scroll positions: one per slide that can be aligned to the start, plus the end.
      // With several slides per view this is fewer than the slides (e.g. 6 slides, 3 per view: 4).
      get pageCount() {
        const slides = this.slides;
        if (slides.length === 0) return 0;
        const maxScroll = this.maxScroll;
        return slides.filter((slide) => slide.offsetLeft - slides[0].offsetLeft < maxScroll - 1).length + 1;
      }

      get currentIndex() {
        const lastIndex = this.pageCount - 1;
        if (this.track.scrollLeft >= this.maxScroll - 1) return lastIndex;
        return Math.min(Math.round(this.track.scrollLeft / this.step), lastIndex);
      }

      goTo(index) {
        const slides = this.slides;
        const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!target) return;
        this.track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }

      update() {
        const scrollable = this.maxScroll > 1;
        this.classList.toggle('carousel-slider--static', !scrollable);

        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= this.maxScroll - 1;

        const pageCount = this.pageCount;
        const currentIndex = this.currentIndex;
        this.dots.forEach((dot, index) => {
          dot.hidden = index >= pageCount;
          if (index === currentIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
